import React from "react";
import { useNavigate } from "react-router-dom";

export default function Sidebar() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col bg-white text-lg">
      {/* Item and right arrow container */}
      <div className="flex items-center justify-between border-b border-t p-6">
        <h1 className="cursor-pointer font-semibold uppercase">Equipment</h1>
        <img
          src="/icons/next.png"
          alt="Right arrow"
          className="h-4 w-4 cursor-pointer"
        />
      </div>
      <div className="flex items-center justify-between border-b p-6">
        <h1 className="cursor-pointer font-semibold uppercase">Apparel</h1>
        <img
          src="/icons/next.png"
          alt="Right arrow"
          className="h-4 w-4 cursor-pointer"
        />
      </div>
      <div className="flex items-center justify-between border-b p-6">
        <h1 className="cursor-pointer font-semibold uppercase">Footwear</h1>
        <img
          src="/icons/next.png"
          alt="Right arrow"
          className="h-4 w-4 cursor-pointer"
        />
      </div>
      <div className="flex items-center justify-between border-b p-6">
        <h1 className="cursor-pointer font-semibold uppercase">Sale</h1>
      </div>
      <div className="flex items-center justify-between border-b p-6">
        <h1
          onClick={() => navigate("/blogs")}
          className="cursor-pointer font-semibold uppercase"
        >
          Blog
        </h1>
      </div>
      <div className="flex items-center justify-between border-b p-6">
        <h1 className="cursor-pointer font-semibold uppercase">
          Team Noya Athletic
        </h1>
      </div>
      <div className="flex items-center justify-between border-b p-6">
        <h1 className="cursor-pointer font-semibold uppercase">Wholesale</h1>
      </div>
      <div className="flex items-center justify-between border-b p-6">
        <h1 className="cursor-pointer font-semibold uppercase">Rewards</h1>
      </div>
    </div>
  );
}
